


























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ICartCourse, IPaypalItem, IPriceTier, IStudentListCartItem, ICoupon } from '@/interfaces';
import { CartGetters, UserGetters } from '@/Getters';
import { AjaxHelper } from '@/AjaxHelper';

import { money } from '@/filters';

import List from '@/components/List.vue';
import ListItem from '@/components/ListItem.vue';
import Btn from '@/components/Btn.vue';
import PaypalBtn from '@/components/PaypalBtn.vue';
import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';

@Component({
  name: 'cart-details-finalize-page',
  components: { List, ListItem, Btn, PaypalBtn, Field, TextField },
  filters: { money }
})
export default class CartDetailsComponent extends Vue {
  @Prop() public priceTiers!: Record<string, IPriceTier[]>;
  
  public coupon = '';
  public loadingCoupon = false;

  public get cartItems(): ICartCourse[] { return this.$store.getters[CartGetters.getCourses]; }
  public get cartCoupon(): ICoupon | null { return this.$store.getters[CartGetters.getCoupon]; }
  public get isAuthenticated(): boolean { return this.$store.getters[UserGetters.isAuthenticated]; }
  public get totalBeforeCoupon(): number { return this.cartItems.reduce((a, x) => a + this.getCartItemPrice(x), 0); }
  public get couponDeduction(): number {
    if (this.cartCoupon === null) return 0;

    if (this.cartCoupon.isPercentage) {
      return this.totalBeforeCoupon * (this.cartCoupon.number / 100);
    } else {
      return this.cartCoupon.number;
    }
  }
  public get total(): number {
    const total = this.totalBeforeCoupon - this.couponDeduction;
    return total > 0 ? total : 0;
  }
  public get paypalItems(): IPaypalItem[] {
    // This is something that needs a reference number for each cart items so we can make an itemized list
    // return this.cartItems.map(x => ({ description: x.fullName, amount: { value: (x.price * x.students.length).toString() } }));

    return [{ description: 'Description for user', amount: { value: this.total.toString() } }];
  }

  public getStudentPrice(student: IStudentListCartItem) {
    if (student.sessionId && student.priceTierId) {
      const tier = this.priceTiers[student.sessionId].find(x => x.id === student.priceTierId);
      if (tier !== undefined) {
        return tier.price;
      }
    }
    return 0;
  }

  public getCartItemPrice(cart: ICartCourse) {
    return cart.studentSessions.reduce((a, x) => a + this.getStudentPrice(x), 0);
  }

  public async applyCoupon() {
    try {
      this.loadingCoupon = true;
      const coupon = await AjaxHelper.get<ICoupon | string>(`/coupon/code/${this.coupon}`);

      if (await this.$store.dispatch('applyCoupon', typeof coupon === 'string' ? null : coupon)) {
        this.coupon = '';
        this.$alert.success('Coupon successfully applied');
      } else {
        this.$alert.warning(`Coupon (${this.coupon}) could not be applied`);
      }
    } catch {
      this.$alert.danger('Something Failed While Applying Coupon');
    } finally {
      this.loadingCoupon = false;
    }
  }
}
